import PricePerPersonWFFMDataExchange from '@/services/PricePerPersonWFFMDataExchange'
import { MAX_PRICE } from '@/services/PricePerPersonWFFMDataExchange'

/**
 * A mixin adding price per person editing logic and data
 */
export default {
  data () {
    return {
      dx: { pricePerPerson: new PricePerPersonWFFMDataExchange(this.form) },
      popups: { pricePerPerson: false },
      pricePerPerson: {
        selected: `0:${MAX_PRICE}`,
        options: [ { name: 'Dowolna', value: `0:${MAX_PRICE}` } ],
      },
    }
  },

  created () {
    this.pricePerPerson = this.dx.pricePerPerson.data
  },

  computed: {
    selectedPricePerPerson () {
      return this.pricePerPerson.options.filter(price => (price.value === this.pricePerPerson.selected) && (price.value !== '0:0'))
    },
    selectedPricePerPersonValue () {
      const selected = this.pricePerPerson.options.find(range => range.value == this.pricePerPerson.selected)
      return selected ? selected.name : this.getLabelForCustomPredefinedOption
    },
    getLabelForCustomPredefinedOption () {
      if (!this.pricePerPerson.selected) return ''
      else {
        const [ priceFrom, priceTo ] = this.pricePerPerson.selected.split(':')
        return `${priceFrom} - ${priceTo} zł`
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/PricePerPerson.js